import React from 'react';
import { IconProps } from '.';

const SvgDocumentCheck = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M1.75 1.75h17.5v7.4h-1.5v-5.9H3.25v16.5h4.813v1.5H1.75V1.75Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M16 22a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='m19.547 15.513-4.25 4.533-2.795-2.485.996-1.122 1.704 1.515 3.25-3.467 1.095 1.026ZM9.5 11.25h-4v-1.5h4v1.5ZM15.5 7.25h-10v-1.5h10v1.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgDocumentCheck;
